import React from 'react'
import AnchorLink from 'react-anchor-link-smooth-scroll'

const CTA = () => {
    return (<>
        <AnchorLink href='#contact' className='btn btn-light fw-bold text-danger'>Get In Touch</AnchorLink>
    </>)
}

export default CTA